import { HttpInterceptorFn } from '@angular/common/http';

import { authInterceptor } from '@/core/auth/interceptors/auth.interceptor';
import { apiBaseInterceptor } from '@/core/http/interceptors/api-base/api-base.interceptor';
import { errorInterceptor } from '@/core/http/interceptors/error/error.interceptor';

// Order is load-bearing: auth must be innermost so it can refresh+retry a 401 before
// error clears the session. Consumed by app.config and session-refresh.integration.spec.ts —
// keep a single copy so a reorder breaks the integration test for real.
export const httpInterceptors: HttpInterceptorFn[] = [
  apiBaseInterceptor,
  errorInterceptor,
  authInterceptor,
];
